import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { NeutralColors, FontSizes } from "@fluentui/theme";
import ListaVerificacion from "./ListaVerificacion";
import personaServicio from "../../services/persona/personaServicio";
import { IInfoPersonaAux } from "../../Interfaces/IPersona";
import { useDetallePersona } from "../../hooks/useDetallePersona";
import { InfoPersona } from "./InfoPersona";
import { Icon, mergeStyleSets, SharedColors, TooltipHost } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import IconHelper from "../../utils/helpers/iconHelper";

const DetallePersona = () => {
  let { id } = useParams(); // para obtner id de persona
  const [infoPersona, setinfoPersona] = useState<IInfoPersonaAux>(null!);
  const [usuario, setusuario] = useState("");
  const { DataInfoSupervisor, nombreSupervisor } = useDetallePersona();

  const navigate = useNavigate();

  const iconData = IconHelper.ICON_BACK;

  const classNames = mergeStyleSets({
    iconFont: {
      padding: 0,
      fontSize: "16px",
      marginRight: 5,
    },
  });
  useEffect(() => {
    if (id != undefined) {
      dataInfoDetallePaciente();
      DataInfoSupervisor(id);
    }
  }, [id]);

  /* api */
  const dataInfoDetallePaciente = () => {
    if (id != undefined) {
      personaServicio
        .personaByID(id)
        .then((persona) => {
          setinfoPersona(persona.data);
          setusuario(persona.data.usuarioId)
        })
        .catch((err) => {
          alert(err.message);
        });
    }
  };

  return (

    <>

      <div
        className="ms-Grid"
        dir="ltr"
        style={{ backgroundColor: NeutralColors.gray10, height: 55 }}
      >
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <div
              className="ms-Grid-col ms-sm12 ms-md12 ms-lg12"
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0 10px", marginTop: "10px",
              }}
            >
              <div>
                <div className="LayoutPage-demoBlock">
                  <div
                    style={{
                      color: NeutralColors.gray130,
                      fontSize: FontSizes.size20,
                    }}
                  >
                    Persona
                  </div>
                </div>
                <div className="LayoutPage-demoBlock">
                  <div
                    style={{
                      color: NeutralColors.gray130,
                      fontSize: FontSizes.size12,
                    }}
                  >
                    Detalle De Persona
                  </div>
                </div>
              </div>
              <TooltipHost>
                <Icon
                  iconName={iconData.iconProps?.iconName}
                  style={{
                    cursor: "pointer",
                    color: '#0078d4',
                    fontSize: "20px",
                  }}
                  onClick={() => navigate(-1)}
                />
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "normal",
                    padding: "20px 0px 0px 5px"
                  }}>Atrás</span>
              </TooltipHost>
            </div>
          </div>
        </div>
      </div>
      <br />
      <InfoPersona
        datosPersona={infoPersona}
        nombreSupervisor={nombreSupervisor}
        personaId={id}
        usuarioId={usuario}
        reload={() => {
          dataInfoDetallePaciente();
          DataInfoSupervisor(id!)
        }}
      />
      <div style={{ margin: '30px' }}>
        <ListaVerificacion />
      </div>
    </>
  )
};
export default DetallePersona;
